import { SET_PUSH_NOTIF, SEND_PUSH_NOTIF } from '../actions/types/index';

export default (
  state = {
    pushNotifs: {},
    clients: [],
    allClients: []
  },
  action
) => {
  switch (action.type) {
    case SET_PUSH_NOTIF:
      return action.payload;
    case SEND_PUSH_NOTIF:
      const newObjectNotif = { ...state };
      const { message, title, nbUsers, date, cible } = action.payload;
      newObjectNotif.pushNotifs[action.payload.date] = {
        message,
        title,
        nbUsers,
        date,
        cible
      };
      return { ...newObjectNotif };
    default:
      return state;
  }
};
